import axios from "axios";
import { configUrl } from "../../config";


export const getPredictedColleges = async (predictorType, rank, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/predictor/${predictorType}/predict-colleges-admin`, {
            rank: rank,
            collegeFrequency: 300,
            branches: branch ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
            city: city ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching AI-predicted colleges:", error);
        throw error;
    }
};


export const getPharmaPredictedColleges = async (rank, branch, category, city, typeValue, quotaValue) => {
    try {
        const response = await axios.post(`${configUrl.PredictorServer}/getPharmaPredictedColleges`, {
            rank: rank,
            branches: branch ? branch : ["All"],
            category: category || "All",
            category_gender_filter: typeValue || "All",
            category_region_filter: quotaValue || "All",
            city: city ? city : ["All"],
        });

        return response?.data;
    } catch (error) {
        console.error("Error fetching AI-predicted colleges:", error);
        throw error;
    }
};